
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.773.75c.766 0 1.532.191 2.27.574.738.383 1.34.875 1.805 1.477.492.683.738 1.394.738 2.16 0 .601-.137 1.148-.383 1.586a3.6 3.6 0 01-.902 1.039c-.246.191-.602.41-1.067.684-.382.218-.656.382-.765.492-.219.191-.328.383-.328.574V9.5a.66.66 0 01-.192.465.64.64 0 01-.465.191H4.516c-.192 0-.356-.054-.465-.191-.137-.11-.192-.274-.192-.465v-.273c0-.711.22-1.34.711-1.86.274-.273.766-.629 1.477-1.012l.055-.027c.492-.273.82-.492.984-.656.219-.219.355-.465.355-.738 0-.383-.218-.711-.628-.985a2.34 2.34 0 00-1.258-.383c-.492 0-.93.137-1.258.356-.274.191-.629.52-1.012.984a.639.639 0 01-.437.274.59.59 0 01-.465-.137l-1.176-.902a.588.588 0 01-.273-.41c-.028-.165.027-.329.136-.493.575-.82 1.23-1.422 1.942-1.832C3.777.97 4.707.75 5.773.75zM5.5 10.95c.52 0 .957.19 1.34.573.355.383.547.82.547 1.34 0 .52-.192.957-.547 1.34-.383.383-.82.547-1.34.547-.547 0-.984-.164-1.34-.547a1.795 1.795 0 01-.547-1.34c0-.52.164-.957.547-1.34.356-.382.793-.574 1.34-.574z"}})])
          )
        }
      }
    